import { useState, useEffect } from 'react';
import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

export function useCustomerBio(firstName: string, lastName: string, city: string, state: string) {
  const [bio, setBio] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function generateBio() {
      try {
        const prompt = `Based on the name ${firstName} ${lastName} from ${city}, ${state}, briefly suggest their likely interests or background in a respectful way. Keep it to one short sentence and be tentative rather than definitive in the suggestion.`;

        const completion = await openai.chat.completions.create({
          messages: [{ role: "user", content: prompt }],
          model: "gpt-3.5-turbo",
        });

        setBio(completion.choices[0]?.message?.content || null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to generate bio');
      } finally {
        setLoading(false);
      }
    }

    generateBio();
  }, [firstName, lastName, city, state]);

  return { bio, loading, error };
}